import "@esri/calcite-components/dist/components/calcite-loader";
import "@esri/calcite-components/dist/components/calcite-progress";
import "@esri/calcite-components/dist/components/calcite-switch";
import styled from "styled-components";

export const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledLoader = styled.div`
  margin: 10rem 0 0;
  color: #c0392b;
  --calcite-color-brand: #c0392b;
  stroke: #c0392b !important;
  --calcite-loader-spacing: 0rem;
`;

export const StyledProgress = styled.div`
  --calcite-color-brand: var(--opsColor);
`;

export const CustomLoader = styled.div`
  padding: 0;
  color: ${({ color }) => (color ? color : "var(--opsColor)")};
  --calcite-color-brand: ${({ color }) => (color ? color : "var(--opsColor)")};
  stroke: ${({ color }) => (color ? color : "var(--opsColor)")} !important;
  --calcite-loader-size: ${({ fontSize }) => fontSize ?? "1.5rem"};
  --calcite-font-size--3: ${({ fontSize }) => fontSize ?? "1.5rem"};
  --calcite-loader-spacing: 0rem;
  --calcite-internal-loader-size: 2rem;
`;

export const CustomSwitch = styled.div`
  --calcite-color-brand: var(--opsColor);
  --calcite-color-brand-hover: var(--opsColor);
  --calcite-ui-focus-color: var(--opsColor);
`;

export const StyledMapSurveyContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 2;
  text-align: center;
  position: relative;
`;

export const StyledDateTime = styled.span`
  font-size: 10px;
  color: #999;
  font-weight: 500;
  display: inline-block;
`;
